import Header from './header';
import Footer from "./footer";

import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";

const Layout = (props) => {
  const [show_printer_effect, setShowPrinterEffect] = useState(false)

  useEffect(() => {
    const isBot = /Lighthouse|baiduspider|Googlebot|bot|crawler|spider|ahrefs|Facebot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkShare/i.test(navigator.userAgent);
    if (!isBot) {
      setShowPrinterEffect(true);
    }
  }, []);
  return (
      <div className="main-content" style={{backgroundColor: '#fafafd'}}>
        {props.special_params &&
            <Helmet>
              <meta name="description" content={props.special_params['description']}/>
              <meta property="og:description" content={props.special_params['description']}/>
              <meta property="og:title" content={props.special_params['document_title']}/>
              <title>{props.special_params['document_title']}</title>
              {'canonical' in props.special_params &&
                  <link rel="canonical" href={`${process.env.REACT_APP_PRINCIPAL_URL}/${props.special_params['canonical']}`}/>
                  &&
                  <meta property="og:url" content={`${process.env.REACT_APP_PRINCIPAL_URL}/${props.special_params['canonical']}`}/>
              }
            </Helmet>
        }
        <Header show_printer_effect={show_printer_effect}  is_mobile={props.is_mobile} header_data={props.header_data} no_header={props.no_header}/>
        <div>{props.children} </div>
        <div style={{marginBottom: '2em'}}></div>
        <Footer offer_loading={props.offer_loading} is_mobile={props.is_mobile}/>
      </div>
  );
};

export default Layout;